import { ErrorBoundary } from 'react-error-boundary'

import { DeliveryForecasts } from '../features/delivery-forecasts/components'
import FallbackErrorMessage from '../utils/errors/FallbackMessage'

export const DeliveryForecastsPage: React.FC = () => {
  return (
    <ErrorBoundary FallbackComponent={FallbackErrorMessage}>
      <DeliveryForecasts />
    </ErrorBoundary>
  )
}
